/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep = {
  ThreeThousandSixHundred: "3600",
  EightySixThousandFourHundred: "86400",
} as const;
export type GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep =
  ClosedEnum<
    typeof GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep
  >;

export type GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest = {
  ledgerCanisterId: string;
  start?: number | undefined;
  end?: number | undefined;
  step?:
    | GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep
    | undefined;
  index?: number | undefined;
};

/** @internal */
export const GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep$inboundSchema:
  z.ZodNativeEnum<
    typeof GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep
  > = z.nativeEnum(
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep,
  );

/** @internal */
export const GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep$outboundSchema:
  z.ZodNativeEnum<
    typeof GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep
  > =
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep$ {
  /** @deprecated use `GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep$inboundSchema` instead. */
  export const inboundSchema =
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep$inboundSchema;
  /** @deprecated use `GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep$outboundSchema` instead. */
  export const outboundSchema =
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep$outboundSchema;
}

/** @internal */
export const GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$inboundSchema:
  z.ZodType<
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    step:
      GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep$inboundSchema
        .default("86400"),
    index: z.number().int().optional(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$Outbound =
  {
    ledger_canister_id: string;
    start?: number | undefined;
    end?: number | undefined;
    step: string;
    index?: number | undefined;
  };

/** @internal */
export const GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$outboundSchema:
  z.ZodType<
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$Outbound,
    z.ZodTypeDef,
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    start: z.number().int().optional(),
    end: z.number().int().optional(),
    step:
      GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetStep$outboundSchema
        .default("86400"),
    index: z.number().int().optional(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$ {
  /** @deprecated use `GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$inboundSchema;
  /** @deprecated use `GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$outboundSchema;
  /** @deprecated use `GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$Outbound` instead. */
  export type Outbound =
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$Outbound;
}

export function getTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequestToJSON(
  getTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest:
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest,
): string {
  return JSON.stringify(
    GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$outboundSchema
      .parse(getTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest),
  );
}

export function getTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetTotalSupplyApiV2LedgersLedgerCanisterIdTotalSupplyGetRequest' from JSON`,
  );
}
